import { useIntercom } from 'react-use-intercom'
import { SupportComponent } from '../../../../../components/stories/organisms/top-navigation/components/utility-icons/support'
import { trackFirebaseEvent } from '../../../../../firebase/firebase-analytics'

const Support = () => {
  const { show } = useIntercom()

  const handleClick = () => {
    trackFirebaseEvent('topnav_help_opened', {
      source: 'top_nav'
    })

    show()
  }

  return <SupportComponent key="support" onClick={handleClick} />
}

export default Support
